// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"index_loadingWrapper__tnp7p","text":"index_text__VAogc"};